import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Timmer = ({ data }) => {
  const [timer, setTimer] = useState("");
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    // Use the stored expiryDate from the backend (set by admin via months selector)
    // Fall back to computing from subscriptionStart if expiryDate is not yet stored
    const getExpiryTime = () => {
      if (data?.expiryDate) {
        return new Date(data.expiryDate).getTime();
      }

      // Legacy fallback: compute from subscriptionStart
      const startDate = data?.subscriptionStart || data?.createdAt;
      if (!startDate) return null;

      const isPaidUser = data?.subscriptionStatus === "paid";
      const months = data?.subscriptionMonths || 1;
      const start = new Date(startDate).getTime();
      const durationMs = isPaidUser
        ? months * 30 * 24 * 60 * 60 * 1000
        : 72 * 60 * 60 * 1000; // 3 days for demo
      return start + durationMs;
    };

    const expiryTime = getExpiryTime();
    if (!expiryTime) {
      setTimer("—");
      return;
    }

    const isPaidUser = data?.subscriptionStatus === "paid";

    const calculateRemainingTime = () => {
      const remaining = expiryTime - Date.now();

      if (remaining <= 0) {
        setIsExpired(true);
        return isPaidUser ? "0 days" : "0 hours";
      }

      setIsExpired(false);
      if (isPaidUser) {
        const days = Math.ceil(remaining / (1000 * 60 * 60 * 24));
        return `${days} day${days !== 1 ? "s" : ""}`;
      } else {
        const hours = Math.ceil(remaining / (1000 * 60 * 60));
        return `${hours} hour${hours !== 1 ? "s" : ""}`;
      }
    };

    setTimer(calculateRemainingTime());
    const interval = setInterval(() => {
      setTimer(calculateRemainingTime());
    }, 60000);

    return () => clearInterval(interval);
  }, [data]);

  return (
    <div>
      <Typography
        sx={{
          fontSize: { xs: "1rem", md: "1rem" },
          textAlign: "center",
          background: isExpired
            ? "linear-gradient(90deg, #ff7b7b, #ff4c4c)"
            : "linear-gradient(90deg, #6a82fb, #fc5c7d)",
          color: "white",
          p: 2,
          fontWeight: 400,
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {isExpired ? (
          <Link
            to="/pricing"
            style={{ cursor: "pointer", textDecoration: "none", color: "white", fontWeight: "bold" }}
          >
            🚨 Your {data?.subscriptionStatus === "paid" ? "Plan" : "Trial"} Has Expired 🚨
          </Link>
        ) : (
          `⏳ ${
            data?.subscriptionStatus === "paid" ? "Plan Expires In" : "Trial Plan Expires In"
          }: ${timer}`
        )}
      </Typography>
    </div>
  );
};

export default Timmer;
